import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import logoUrl from '../../../assets/images/quazbit-logo.svg';
import './AuthBrand.css';

function AuthBrand({ href, to, corner = false }) {
    const className = corner ? 'auth-brand auth-brand--corner' : 'auth-brand';
    const content = (
        <>
            <img src={logoUrl} alt="Quazbit" className="auth-brand-logo" />
            <span className="auth-brand-name">Quazbit</span>
        </>
    );

    if (href) {
        return (
            <a className={className} href={href}>
                {content}
            </a>
        );
    }

    if (to) {
        return (
            <Link className={className} to={to}>
                {content}
            </Link>
        );
    }

    return <div className={className}>{content}</div>;
}

AuthBrand.propTypes = {
    href: PropTypes.string,
    to: PropTypes.string,
    corner: PropTypes.bool,
};

export default AuthBrand;
